module.exports = __webpack_public_path__ + "img/phone4-icon.1cc62e0d.png";